import { defineStore } from 'pinia'

export const useProductsCartStore = defineStore('productsCart', {
  state: () => {
    return { 
        pais: '',
        articulos: [],
        total: 0
    }
  },
  actions: {

    addProduct(articulo) {
      if(!articulo.nombre && !articulo.cantidad
      && !articulo.costo && !articulo.divisa && !articulo.divisa_simbolo){
        return
      }
        for(let item in this.articulos) {
          if(this.articulos[item].producto.toLowerCase() === articulo.nombre.toLowerCase()) {
            this.articulos[item].cantidad ++;
            this.totalProductsCart()
            return;
          }
        }
        let item = {
            id: Date.now(),
            id_articulo: articulo.id ?? null,
            producto: articulo.nombre.toLowerCase(),
            pais: this.pais,
            divisa: articulo.divisa,
            divisa_simbolo: articulo.divisa_simbolo,
            costo: articulo.costo,
            cantidad: articulo.cantidad,
            bateria: articulo.bateria ? 1 : 0
        };

        this.articulos.push(item);
        this.totalProductsCart()
      },

      updateProduct(articulo) {
        if(!articulo.nombre && !articulo.cantidad
          && !articulo.costo && !articulo.divisa && !articulo.divisa_simbolo){
            return
        }
        let found = this.articulos.find(p => p.id == articulo.id)
        if(found){
          found.producto = articulo.nombre
          found.divisa = articulo.divisa
          found.divisa_simbolo = articulo.divisa_simbolo
          found.costo = articulo.costo
          found.cantidad = articulo.cantidad
          found.bateria = articulo.bateria
          this.totalProductsCart()
        }
      },

    vaciarArticulos(){
        this.pais = ''
        this.articulos = []
        this.total = 0
    },

    aumentarArticulos(id) {
        const item = this.articulos.find(a => a.id === id)
        if(item) {
            item.cantidad++
            this.totalProductsCart()
        }
    },

    aumentarArticuloByCantidad(id, cantidad = 0){
      const item = this.articulos.find(a => a.id === id)
      if(item) {
          item.cantidad = Number(cantidad)
          this.totalProductsCart()
      }
    },

    disminuirArticulos(id){
        const idx = this.articulos.findIndex(a => a.id === id)
        if(idx === -1) return
        this.articulos[idx].cantidad--
        if(this.articulos[idx].cantidad <= 0) {
            this.articulos.splice(idx, 1)
        }
        this.totalProductsCart()
    },

    eliminarProducto(id){
        const idx = this.articulos.findIndex(a => a.id === id)
        if(idx !== -1) {
            this.articulos.splice(idx, 1)
        }
    },

    totalProductsCart () {
        let totalProductos = 0;
        for(let item of this.articulos) {
            totalProductos += (item.costo * item.cantidad)
        }
        this.total = Number(totalProductos.toFixed(2));
    },

  }, 
})